import React from "react";
import type { SrChatChart } from "./sr-chat-chart-types";

type Props = { chart: SrChatChart };

export const SrChatBarChart: React.FC<Props> = ({ chart }) => {
    const max = Math.max(...chart.data.map((d) => d.value), 1);

    return (
        <div className="sr-chat-chart my-2 rounded-xl border border-slate-200/90 bg-slate-50/50 p-3">
            <div className="mb-2 flex items-baseline justify-between gap-2">
                <p className="text-sm font-semibold text-slate-800">{chart.title}</p>
                {chart.total != null && (
                    <span className="text-xs text-slate-500">Total {chart.total}</span>
                )}
            </div>
            <div className="space-y-2">
                {chart.data.map((row) => (
                    <div key={row.label} className="grid grid-cols-[minmax(0,1fr)_auto] items-center gap-2">
                        <div className="min-w-0">
                            <p className="truncate text-xs text-slate-600">{row.label}</p>
                            <div className="mt-1 h-2 overflow-hidden rounded-full bg-slate-200/80">
                                <div
                                    className="h-full rounded-full bg-[#3A80F4]"
                                    style={{ width: `${(row.value / max) * 100}%` }}
                                />
                            </div>
                        </div>
                        <span className="text-xs font-medium tabular-nums text-slate-700">
                            {row.value}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
};
